<template>
  <div
    v-if="drmSettings.providers.length"
    class="px-2 pb-1"
  >
    <b-row class="align-items-center pb-1">
      <b-col>
        <b-form-checkbox
          v-model="useDrm"
          name="use_wide-wine"
          switch
        >
          <span>Use DRM</span>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <transition-group
      name="fade"
      tag="div"
    >
      <template v-if="useDrm">
        <b-row key="firstRow">
          <b-col
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="DRM"
              class="w-100"
            >
              <input-field
                name="drm-provider"
                label="DRM Provider *"
                label-position="top"
                :error="errors.length ? errors[0] : null"
                info-position="label"
              >
                <custom-select
                  id="drm-provider"
                  v-model="groupDrm.shakaPackagerKeyProviderType"
                  placeholder="Select DRM provider"
                  :options="getNameOptions(drmSettings.providers)"
                  :state="errors.length > 0 ? false : null"
                />
              </input-field>
            </validation-provider>
          </b-col>
          <b-col
            v-if="
              groupDrm.shakaPackagerKeyProviderType ===
                drmSettings.rawKey.rawKeyId
            "
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Raw key label"
              class="w-100"
              rules="required"
            >
              <input-field
                name="drm-rawLabels"
                label="Raw Key Label *"
                label-position="top"
                :error="errors.length ? errors[0] : null"
                info-position="label"
              >
                <custom-select
                  id="drm-rawLabels"
                  v-model="groupDrm.label"
                  placeholder="Select segment control"
                  :options="getFlatOptions(drmSettings.rawKey.labels)"
                  :state="errors.length > 0 ? false : null"
                />
              </input-field>
            </validation-provider>
          </b-col>
          <b-col
            v-else-if="
              groupDrm.shakaPackagerKeyProviderType ===
                drmSettings.widevineAlgorithm.widevineId
            "
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Widevine Algorithm"
              class="w-100"
            >
              <input-field
                name="drm-widevineAlgorithms"
                label="Widevine Algorithms  *"
                label-position="top"
                :error="errors.length ? errors[0] : null"
                info-position="label"
              >
                <custom-select
                  id="drm-widevineAlgorithms"
                  v-model="groupDrm.encryptionAlgorithmType"
                  placeholder="Select segment control"
                  :options="
                    getTypeOptions(drmSettings.widevineAlgorithm.algorithms)
                  "
                  :state="errors.length > 0 ? false : null"
                />
              </input-field>
            </validation-provider>
          </b-col>
          <b-col v-else />
        </b-row>
        <b-row key="secondRow">
          <b-col
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Protection Schema"
              class="w-100"
            >
              <input-field
                name="drm-protection_schema"
                label="Protection Schema *"
                label-position="top"
                :error="errors.length ? errors[0] : null"
                info-position="label"
              >
                <custom-select
                  id="drm-provider"
                  v-model="groupDrm.protectionSchemaType"
                  placeholder="Select protection schema control"
                  :options="getOptions(groupDrm.protectionSchemaOptions)"
                  :state="errors.length > 0 ? false : null"
                />
              </input-field>
            </validation-provider>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Clear lead"
              class="w-100"
              rules="required|max_value:500|min_value:0"
            >
              <input-field
                name="drm-clear_lead"
                label="Clear Lead *"
                label-position="top"
                :error="errors.length ? errors[0] : null"
                info-position="label"
              >
                <b-form-input
                  id="file_group-segment_length"
                  v-model="groupDrm.clearLead"
                  type="number"
                  min="0"
                  max="500"
                  placeholder="Enter clear lead here..."
                  :state="errors.length > 0 ? false : null"
                />
              </input-field>
            </validation-provider>
          </b-col>
        </b-row>
      </template>
    </transition-group>
  </div>
  <div
    v-else
    class="px-2 pb-1"
  >
    <p class="text-secondary">
      You haven't configured DRM yet.
    </p>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate'
import { required } from '@validations'

import { min_value, max_value } from 'vee-validate/dist/rules'

import InputField from '@/components/form/InputField.vue'

extend('min_value', min_value)
extend('max_value', max_value)

export default {
  name: 'DRMSettings',
  components: {
    ValidationProvider,
    InputField,
  },
  props: {
    hasDrm: {
      type: Boolean,
      required: true,
    },
    groupDrm: {
      type: Object,
      required: true,
    },
    drmSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      groupDRM: null,
      rawKeyLabel: null,
      wideWineAlgorithm: null,
      useDrm: false,
    }
  },
  watch: {
    useDrm(val) {
      this.$emit('useDrm', val)
    },
  },
  created() {
    this.useDrm = this.hasDrm
  },
  methods: {
    getNameOptions(arr) {
      return arr.map(i => ({ text: i.name, value: i.id }))
    },
    getTypeOptions(arr) {
      return arr.map(i => ({ text: i.type, value: i.id }))
    },
  },
}
</script>
